var React = require('react');

function AddInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.8334 7.09383C10.8542 6.96716 8.87508 6.91175 6.90383 6.90383C6.90383 8.87508 6.96716 10.8622 7.09383 12.8334H5.90633C6.033 10.8542 6.08841 8.87508 6.09633 6.90383C4.12508 6.90383 2.138 6.96716 0.166748 7.09383V5.90633C2.14591 6.033 4.12508 6.08841 6.09633 6.09633C6.09633 4.12508 6.033 2.138 5.90633 0.166748H7.09383C6.96716 2.14591 6.91175 4.12508 6.90383 6.09633C8.87508 6.09633 10.8622 6.033 12.8334 5.90633V7.09383Z","fill":"black"}));
}

AddInline.defaultProps = {"width":"13","height":"13","viewBox":"0 0 13 13","fill":"none"};

module.exports = AddInline;

AddInline.default = AddInline;
